<p class="captcha-terms">
  This site is protected by reCAPTCHA and the Google
  <a target="_blank" href="{{privacyPolicyLink}}">Privacy Policy</a> and
  <a target="_blank" href="{{termsOfServiceLink}}">Terms of Service</a> apply.
</p>